enum EligibilityToggleValue {
  YES = 'Yes',
  NO = 'No',
  UNSURE = 'Unsure',
}

export default EligibilityToggleValue
